import { RenderFunc } from '../types/RenderFunc';

export const renderPrescriptionForUnidentifiedPersons: RenderFunc = item => {
  const { newValue, oldValue } = item;
  let oldValueText = '';
  let newValueText = '';

  if (oldValue === true) {
    oldValueText = 'Неограниченный круг лиц';
  } else if (oldValue === false) {
    oldValueText = 'Контролируемое лицо';
  }
  if (newValue === true) {
    newValueText = 'Неограниченный круг лиц';
  } else if (newValue === false) {
    newValueText = 'Контролируемое лицо';
  }

  return {
    renderedOldValue: oldValueText,
    renderedNewValue: newValueText,
  };
};
